import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

// Create a theme instance.
const genTheme = createTheme({
  palette: {
    background: {
      default: "#FFFAFA",
    },
    primary: {
      main: "#C21B17",
      light: "#701230",
      dark: "#C21B17",
    },
    secondary: {
      main: "#6F7072",
      light: "#B0B2B3",
      dark: "#656565",
    },
    error: {
      main: red.A400,
    },
    success: {
      main: "#2e7d32",
    },
  },
  typography: {
    fontSize: 14,
    fontFamily:
      "Noto Sans Thai, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    h1: {
      color: "#C6251D",
      fontSize: 32,
      fontWeight: "bold",
    },
    h2: {
      color: "#C6251D",
      fontSize: 26,
      fontWeight: "normal",
    },
    h3: {
      color: "#919191",
      fontSize: 24,
      fontWeight: "normal",
    },
    h4: {
      color: "#919191",
      fontSize: 20,
      fontWeight: "normal",
    },
    h5: {
      color: "#111111",
      fontSize: 20,
      fontWeight: "bold",
    },
    body1: {
      color: "#111111",
    },
    body2: {
      color: "#656565",
      fontSize: 14,
    },
    caption: {
      color: "#BABABA",
      fontSize: 12,
    },
  },
  components: {
    MuiPaper: {
      defaultProps: {
        sx: {
          backgroundColor: "#FFFFFF",
        },
      },
    },
  },
});

export default genTheme;
